import React, { useState, useEffect } from "react";
import { Button, CheckedImage, Input } from "../../../common/commonIndex";
import { Image } from "../../../components/componentIndex";

const QuestionTypeNumber = ({ handleNextEvent, formData, questionData }) => {
    const [ageDiagnosis, setAgeDiagnosis] = useState(formData?.answer || '');
    const [isAgeDiagnosisValid, setIsAgeDiagnosisValid] = useState(false);
    
    useEffect(() => {
        if (formData?.answer) {
            setAgeDiagnosis(formData?.answer);
            setIsAgeDiagnosisValid(true);
        } else {
            setAgeDiagnosis('');
            setIsAgeDiagnosisValid(false);
        }
    });
    
    
    const handleDiagnosisChange = (e) => {
        const value = e;
        setAgeDiagnosis(value);
        setIsAgeDiagnosisValid(value?.trim() !== '' ? true : false);
        formData.answer = value;
        formData.fkAnswerIds = value;
    }
    // Handle form submission
    const handleSubmit = (e) => {
        // e.preventDefault();
        // skip then 2 otherwise 1
        let skip = 1;
        // if(questionData?.skippedNestedQuestionID){
        //     skip = 2;
        // }
        const findData = getLocalStorageData();
        findData[questionData.questionerIndex] = formData;
        setLocalStorageData(findData);
        handleNextEvent(questionData?.questionerIndex + skip);
    };
    const getLocalStorageData = () =>{
        const findlocalStorageData =  JSON.parse(localStorage.getItem('listOfAnswer'));
         return findlocalStorageData;
     }
     const setLocalStorageData = (data) =>{
       if(data?.length > 0){
         localStorage.setItem('listOfAnswer', JSON.stringify(data));
       }
     }
    return (
        <>
            <h3 className="title">{questionData.question}</h3>
            <div className="eligibility questionnaire">
                <form className="padding-top-25">
                    <div className={`input-group mb-3 ${isAgeDiagnosisValid ? 'valid' : ''}`}>
                        <Input inputType={'number'} inputPlaceholder={questionData?.question ? questionData?.question : `Enter age at diagnosis`} className={'form-control'} required={true} onChange={handleDiagnosisChange}
                            value={ageDiagnosis} />
                        {isAgeDiagnosisValid && (
                            <CheckedImage />
                        )}
                    </div>
                </form>
            </div>
            
            <div className="questionnaire-fix-btn eligibility-fix-btn">
                <div className="divider "></div>
                <div className="footer-content">
                    <div className="skip-eligibility">
                    </div>
                    <Button
                        btnClass={'btn-primary question-btn'}
                        btnType={'button'}
                        btnName={'Continue'}
                        onClick={handleSubmit}
                        isDisabled={isAgeDiagnosisValid}
                    />
                </div>
            </div>

        </>
    )
};

export default QuestionTypeNumber;